import React from 'react';
import { useWatchlistSearchModule } from '../../Modules';
import {
  WatchlistSearchItemData,
  WatchlistSearchItem,
  createWatchlistSearchItem,
  isWatchlistSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface WatchlistExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { watchlist_id: string };
}

export interface WatchlistExpressionModule extends ExpressionModule<WatchlistSearchItemData> {
  toTokenData: (item: SearchItem) => WatchlistExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => WatchlistSearchItem | undefined;
}

export const isWatchlistExpressionData = (token: TokenData<unknown>): token is WatchlistExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'watchlist_id' in token.rightOperand
  );
};

export const createWatchlistExpressionModule = (): WatchlistExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isWatchlistExpressionData(token)) return undefined;
      return createWatchlistSearchItem(token.rightOperand.watchlist_id);
    },
    toTokenData: item => {
      if (!isWatchlistSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { watchlist_id: item.data.watchlistId },
      };
    },
  };
};

export const useWatchlistExpressionSearchModule = (): ExpressionSearchModule => {
  const watchlistModule = useWatchlistSearchModule();
  return React.useMemo(
    () => ({ ...watchlistModule, expression: createWatchlistExpressionModule() }),
    [watchlistModule],
  );
};
